<template>
  <v-row data-qa="login-row-nzaqs6">
    <v-overlay v-if="loaderEnabled" :opacity="0.5" data-qa="login-overlay-a4ndig">
      <v-progress-circular
        :color="primaryColor"
        :size="70"
        :width="7"
        indeterminate
        class="circular-loader"
       data-qa="login-progress-circular-bdq57"></v-progress-circular>
    </v-overlay>

    <!-- Terms & Conditions -->
    <ConsentOverlay
      v-if="enableTermsAndConditionsConsent && consentConfig.showConsent"
      :consentConfig="consentConfig"
    ></ConsentOverlay>

    <v-layout v-if="!currentActionType || !consentConfig.showConsent" row data-qa="login-layout-tsy952">
      <v-flex xs12 sm6 md6 lg6 xl6 class="login__alignCard" data-qa="login-flex-peaten">
        <v-row no-gutter justify="center" data-qa="login-row-oh8d2u">
          <!-- <v-flex data-qa="login-flex-avi31s"  lg2 xl2 /> -->
          <v-flex lg9 xl9 class="ml-12" data-qa="login-flex-3v5w2j">
            <v-card flat class="pa-4" data-qa="login-card-t2dwi">
              <v-flex xs12 sm12 md12 lg8 xl8 data-qa="login-flex-m7mhed">
                <img data-qa="login-img-jt21y"
                  alt="logo"
                  height="80px"
                  width="140px"
                  :src="logo"
                  id="images"
                  class="loginTitle"
                />
                <br data-qa="login-br-aeqnt9"  />
                <div
                  v-cloak
                  class="text-uppercase text-h5 font-weight-black pt-10"
                 data-qa="login-div-lvezqf">
                  {{ $t("common.welcomeTitle") }}
                </div>
                <div
                  v-cloak
                  class="text--secondary text-h6 pt-1 font-weight-bold"
                 data-qa="login-div-3ro5fk">
                  {{ $appSettings.applicationSettings.applicationName }}
                </div>
              </v-flex>
              <v-flex class="mt-2" xs10 sm10 md9 lg8 xl8 data-qa="login-flex-za6vom">
                <!--Form Tabs Control-->
                <v-tabs
                  v-if ="showTabs"
                  v-model="currentTab"
                  @change="handleTabChange"
                  :color="primaryColor"
                 data-qa="login-tabs-6v1skp">
                  <!--Tab Labels and Icons hardcoded here due to issue with loading locale-->
                  <v-tab v-for="(item, i) of [{ icon: 'login_personaltab', label: $t('login.tabLabels.personal') },
                    { icon: 'login_smetab', label: $t('login.tabLabels.sme') }]" :key="i" :data-tab="item.label" :data-qa="`login-tab-hq424m-${i}`">
                    <!-- <v-icon
                      dark
                      left
                      :data-qa="`login-icon-wo696-${i}`">
                      {{ item.icon }}
                    </v-icon> -->
                    <dob-icon :iconKey="item.icon" dark left/>
                    <font class="subtitle-1 text-capitalize font-weight-bold">{{
                      item.label
                    }}</font>
                  </v-tab>
                </v-tabs>
                <!--Login Form-->
                <v-card-text class="pa-0 pt-6" data-qa="login-card-text-p8cr8ka">
                  <v-form ref="loginForm" class="slide-fade" data-qa="login-form-xf52o">
                    <!--SME ID Field-->
                      <v-text-field
                        v-if="showSmeField"
                        v-cloak
                        :label="$t('common.loginSmePlaceholder')"
                        name="smecustomerid"
                        autocomplete="off"
                        data-qa="smeUserID"
                        :rules="[v => !!v || $t('login.smeIdRequiredMessage'), rules.noSpaceRule]"
                        required
                        :error="errorLogin"
                        prepend-inner-icon="mdi-briefcase-variant-outline"
                        type="text"
                        :color="primaryColor"
                        filled
                        :maxlength="
                          $appSettings.defaultConfigurations.loginPageScreens.usernameMaxLength
                        "
                        :class="['login-textfield', showClass]"
                        v-model="corporateId"
                        @blur="focus()"
                        @keyup.enter="corporateId.length > 0 ? login() : false"
                      />
                    <!--Login ID Field-->
                    <v-text-field
                      v-cloak
                      :label="loginLabel"
                      name="username"
                      autocomplete="off"
                      data-qa="userID"
                      :rules="loginInputRules"
                      required
                      :error="errorLogin"
                      prepend-inner-icon="mdi-account-outline"
                      type="text"
                      :color="primaryColor"
                      filled
                      :maxlength="maxLength"
                      :minlength="
                        $appSettings.defaultConfigurations.loginPageScreens.usernameMinLength
                      "
                      class="login-textfield show"
                      v-model="email"
                      @input="validateLoginField"
                      @keyup.enter="email.length > 0 ? login() : false"
                    />
                    <!--Password Field-->
                    <v-text-field
                      v-cloak
                      id="userpassword"
                      :label="$t('common.loginpasswordPlaceholder')"
                      name="userpassword"
                      autocomplete="off"
                      data-qa="password"
                      :rules="[rules.required]"
                      required
                      :error="errorLogin"
                      :error-messages="errorMessage"
                      prepend-inner-icon="mdi-lock-outline"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="() => (showPassword = !showPassword)"
                      :type="showPassword ? 'text' : 'password'"
                      filled
                      :maxlength="
                        $appSettings.defaultConfigurations.loginPageScreens.passwordMaxLength
                      "
                      :color="primaryColor"
                      class="login-textfield show"
                      v-model="userpassword"
                      @blur="focus()"
                      @keyup.enter="userpassword.length > 0 ? login() : false"
                    />
                  </v-form>
                </v-card-text>
                <v-btn
                  id="loginButton"
                  aria-label="loginButton"
                  class="white--text text-capitalize py-2 px-4"
                  :color="primaryColor"
                  depressed
                  :disabled="isLoginButtonDisabled"
                  @click="login"
                 data-qa="login-btn-w04faq">
                  <dob-icon iconKey="login_loginbutton"/>
                  <!-- <v-icon left size="18px" class="px-2 mt-1 material-symbols-outlined" data-qa="login-icon-yduhbm">arrow_right_alt</v-icon> -->
                  <span v-cloak class="login-btn-text" data-qa="login-span-hty07">
                    <!-- <inline-svg src="@/assets/SVG_icons/Outlined_arrow_right.svg"/> -->
                    {{ $t("common.loginButtonPlaceholder") }}
                  </span>
                </v-btn>
                <br data-qa="login-br-c898bn"  />
                <v-row justify="center" class="mt-4" data-qa="login-row-sra5p">
                  <span v-cloak data-qa="login-span-j53trn">{{ $t("common.forgot") }}</span>
                  <a
                    :style="{ color: primaryColor }"
                    class="px-2 font-weight-bold"
                    target="_blank"
                    @click="screenActions({type: 'retrieveLoginId', subType: ''})"
                     data-qa="login-a-k39al">{{
                      $t("login.actionScreen.labelsOnLoginScreen.forgotLoginId")
                    }}</a
                  >
                  <span v-cloak data-qa="login-span-va243b">{{ $t("common.or") }}</span>
                  <a
                    :style="{ color: primaryColor }"
                    class="px-2 font-weight-bold"
                    target="_blank"
                    @click="screenActions({type: 'resetPassword', subType: ''})"
                   data-qa="login-a-bfv5nr">
                    <span v-cloak data-qa="login-span-3latcy">{{
                      $t(
                        "login.actionScreen.labelsOnLoginScreen.forgotPassword"
                      )
                    }}</span>
                  </a>
                </v-row>
                <br data-qa="login-br-8hwlr"  />
                <v-row justify="center" class="mt-4" data-qa="login-row-nyjkc0f">
                  <a
                    :style="{ color: primaryColor }"
                    class="px-2 font-weight-bold"
                    @click="screenActions({type: 'registerForOnlineBanking', subType: ''})"
                    target="_blank"
                   data-qa="login-a-ssyzos">
                    <span v-cloak data-qa="login-span-vc10rm">{{
                      $t("login.actionScreen.labelsOnLoginScreen.activateUser")
                    }}</span>
                  </a>
                </v-row>
              </v-flex>
              <br data-qa="login-br-0ew6a"  />
              <v-layout class="mt-4" row data-qa="login-layout-qdgn4g">
                <v-flex data-qa="login-flex-3yc5n"  xs7 sm7 md6 lg6 xl6 />
                <v-flex xs2 sm2 md2 lg1 xl1 class="ml-8" data-qa="login-flex-joqlu">
                  <!-- <v-icon large data-qa="login-icon-oh016h">mdi-shield-account</v-icon> -->
                  <dob-icon iconKey="login_securelogin" large/>
                </v-flex>
              </v-layout>
              <v-row class="px-1" data-qa="login-row-6pa4bv">
                <v-flex xs7 sm7 md6 lg6 xl6 data-qa="login-flex-75xpgk">
                  <a
                    :style="{ color: primaryColor }"
                    class="px-2"
                    target="_blank"
                    @click="openFaq"
                   data-qa="login-a-hrrjm">
                    <span v-cloak data-qa="login-span-27i3sg">{{ $t("common.support") }}</span>
                  </a>
                  /
                  <a
                    :style="{ color: primaryColor }"
                    class="px-2"
                    target="_blank"
                    @click="openContactUs"
                   data-qa="login-a-ys49l8">
                    <span v-cloak data-qa="login-span-p58mt6">{{ $t("common.finastraContactLink") }}</span>
                  </a>
                </v-flex>
                <v-flex class="ml-1" xs4 sm4 md4 lg4 xl4 data-qa="login-flex-ipt0nk">
                  <font :color="primaryColor" class="font-weight-bold">
                    <span v-cloak data-qa="login-span-z08fyun">{{ $t("common.secure") }}</span>
                  </font>
                  <font class="text-lowercase">
                    <span v-cloak data-qa="login-span-n4c2rk">{{
                      $t("common.loginButtonPlaceholder")
                    }}</span></font
                  >
                </v-flex>
              </v-row>
              <br data-qa="login-br-7wxsgd"  />
            </v-card>
          </v-flex>
        </v-row>
        <!-- TODO
          <v-flex class="mx-12 px-12" data-qa="login-flex-gijyac">
          <v-row data-qa="login-row-tcutlg">
            <v-flex xs12 sm12 md6 lg6 xl6 class="pa-2" data-qa="login-flex-hp9h7m">
              <v-card data-qa="login-card-1o88m">
                <v-card-title class="mx-2" data-qa="login-card-title-h6hcgi">
                  <v-icon class="pr-2" :color="primaryColor"
                     data-qa="login-icon-e7hibi">mdi-help-circle</v-icon
                  >
                  <div class="text-subtitle-1" :color="primaryColor" data-qa="login-div-k410b6">
                    {{ $t("common.needHelp") }}
                  </div>
                </v-card-title>
                <v-card-text class="px-3" data-qa="login-card-text-pez9cd">
                  <a
                    class="login_page_links pl-4 d-flex"
                    target="_blank"
                    @click="screenActions('resetPassword')"
                     data-qa="login-a-wu5lc9">{{ $t("common.resetPasswordPlaceholder") }}</a
                  >
                  <a
                    class="login_page_links pt-2 pl-4 d-flex"
                    target="_blank"
                    @click="screenActions('retrieveLoginId')"
                     data-qa="login-a-m9l1o">{{ $t("common.retrieveLoginId") }}</a
                  >
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 sm12 md6 lg6 xl6 class="pa-2" data-qa="login-flex-x1ugi">
              <v-card data-qa="login-card-juencs">
                <v-card-title class="mx-2" data-qa="login-card-title-29u6jg">
                  <v-icon :color="primaryColor" class="pr-2"
                     data-qa="login-icon-zmm0f">mdi-link-variant</v-icon
                  >
                  <div class="text-subtitle-1" :color="primaryColor" data-qa="login-div-jb0r6t">
                    {{ $t("common.quickLinks") }}
                  </div>
                </v-card-title>
                <v-card-text class="px-3" data-qa="login-card-text-ytz5x9">
                  <a
                    class="login_page_links pl-4 d-flex"
                    target="_blank"
                    @click="openFaq"
                     data-qa="login-a-kx0dm7">{{ $t("common.faqLink") }}</a
                  >
                  <a
                    class="login_page_links pt-2 pl-4 d-flex"
                    target="_blank"
                    @click="openContactUs"
                     data-qa="login-a-r14yvm">{{ $t("common.contactUs") }}</a
                  >
                </v-card-text>
              </v-card>
            </v-flex>
          </v-row>
        </v-flex> -->
      </v-flex>
      <v-flex data-qa="login-flex-5xsib"
        v-if="!showBgImage"
        :style="{ background: gradients }"
        id="gradient"
        class="box hidden-xs-only"
        xs12
        sm6
        md6
      />
      <v-flex data-qa="login-flex-i9djco"
        v-if="showBgImage"
        :style="{ backgroundImage: 'url(' + image + ')' }"
        id="bgImg"
        class="box login__bgImages hidden-xs-only"
        xs12
        sm6
        md6
        lg6
        xl6
      />
    </v-layout>

    <Modal v-if="modalConfig.enabled" :config="modalConfig" @btn1Action="modalConfig.enabled = false">
      <span slot="modalContent" class="font-weight-bold" data-qa="login-span-zm7wy">
        <DobFAQ />
      </span>
    </Modal>

    <Modal
      v-if="enableOTP && showOTPScreen"
      :config="otpModalConfig"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="login-span-gyh1y">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>

    <Modal :config="sessionTimeoutConfig" />
  </v-row>
</template>
<script>
import '@/styles/pages/login/login.scss'
import event from '@/util/event'
import preload from '@/util/preload'
import commonService from '@/service/commonService.js'
import handleError from '@/core/_helpers/errorHandler'
import ConsentOverlay from '@/components/consentManagement/ConsentOverlay.vue'
import defaultBgImage from '@/assets/login.jpg'
import b2cMixin from '@/core/mixins/b2cMixin'
import consentMixin from '@/core/mixins/getConsentData.js'
import smeRolesMixin from '@/core/mixins/smeRolesMixin.js'
import hashed from '@/core/_helpers/crypt'
import store from '@/core/store'
import moment from 'moment'

export default {
  name: 'login',
  components: {
    ConsentOverlay,
    Modal: () => import('@/components/common/Modal.vue'),
    DobFAQ: () => import('@/views/common/DobFAQ.vue'),
    OtpInput: () => import('@/components/common/OtpInput.vue')
  },
  data () {
    return {
      showTabs: false,
      showSmeField: false,
      showClass: '',
      corporateId: '',
      currentTab: 0,
      /** There is some issue with loading the locale equivalent when writtenn like this - using the array as such inside the JSX part
      tabLabels: [{ icon: 'mdi-account-outline', label: this.$t('login.tabLabels.personal') },
        { icon: 'mdi-domain', label: this.$t('login.tabLabels.sme') }
      ], */
      checked: true,
      hasFocus: true,
      email: '',
      userpassword: '',
      feusId: '',
      btndisabled: true,
      resetPassword: false,
      retrieveLoginId: false,
      isLoginIdValid: false,
      registerForOnlineBanking: false,
      isChangeTemporaryPassword: false,
      loginRules: [v => Boolean(v)],
      errorLogin: false,
      errorMessage: undefined,
      modalConfig: {
        btn1Label: 'OK',
        outlinedSaveBtn: false,
        outlinedCancelBtn: true,
        enabled: false,
        persistent: true,
        saveButton: '',
        title: this.$t('login.faq.faqTitle'),
        width: 700
      },
      loaderEnabled: false,
      enableOTP: this.$appSettings.defaultConfigurations.loginPageScreens.enableOTPForLogin,
      showOTPScreen: false,
      otpModalConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      sessionTimeoutConfig: {
        enabled: false,
        persistent: true,
        close: true,
        title: this.$t('common.idleTimeoutTitle'),
        body: this.$t('common.sessionLoggedOutText'),
        width: 400
      },
      otpSettings: {
        resetPasswordTime: 6000,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      rules: {
        required: (value) => !!value || this.$t('login.passwordRequiredMessage'),
        minlength: (value) => value.length >= this.$appSettings.defaultConfigurations.loginPageScreens.passwordMinLength || this.$t('registerUser.loginIdMinLength', { minLen: this.$appSettings.defaultConfigurations.loginPageScreens.passwordMinLength }),
        noSpaceRule: (v) => {
          if (v) {
            return (
              v.match(/^([^ !@#\\$%\\^&\\*][a-zA-Z0-9]*)$/g) || this.$t('errors.common.invalidChar')
            )
          } else return ''
        }
      },
      digiAccess: false,
      isCustomerAuthorized: undefined,
      showBgImage: false,
      enableBgImage: undefined,
      image: undefined,
      showPassword: '',
      activateUser: false,
      currentActionType: '',
      isSmeIdAvailableInUserCoporates: false,
      isSmeLogin: false,
      customerCode: '',
      lastLoginTimeStamp: '',
      checkUpdatedTCFromDate: '',
      checkUpdatedTCFromDay: this.$appSettings.defaultConfigurations.consentManagement.checkUpdatedTCFromDay,
      invalidBankPartyStatus: ['BLOCKED', 'INACTIVE', 'CLOSED'],
      validKycStatus: ['001'],
      bankPartyStatus: '',
      kycStatus: '',
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      messageContent: 'login.bankPartyStatus.content',
      kycStatuses: {
        '002': 'PENDING',
        '003': 'NON_COMPLIANT',
        '004': 'CAUTIONARY',
        KYCCHECKDUE: 'SCHEDULED'
      }
    }
  },
  mixins: [b2cMixin, consentMixin, smeRolesMixin],
  async created () {
    if (!this.get('navigationMenu')) this.set('navigationMenu', this.$navigation.menuStructure)
    if (this.$route.params && this.$route.params.from === 'IdleTimeout') { this.sessionTimeoutConfig.enabled = true }
    this.getAppDefaultConfig()
    if (this.enableTermsAndConditionsConsent) {
      // Check for updated T&C based on the day of "this.checkUpdatedTCFromDay"
      this.checkUpdatedTCFromDay = this.checkUpdatedTCFromDay.toString().length === 1
        ? `0${this.checkUpdatedTCFromDay}` : this.checkUpdatedTCFromDay
      this.checkUpdatedTCFromDate = moment().format(`${this.checkUpdatedTCFromDay}-MM-YYYY`)
    }
    event.$on('showLoginScreen', arg => {
      this.currentActionType = ''
    })
    event.$on('DIGITAL_CHANNEL_ACCESS', async arg => {
      const { bankPartyStatus, isDigiAccessAllowed, kycStatus } = arg
      this.bankPartyStatus = bankPartyStatus
      this.kycStatus = kycStatus
      if (this.kycStatuses[kycStatus] && this.currentTab === 1) this.messageContent = `login.invalidKycStatus.KYC_STATUS_${this.kycStatuses[kycStatus]}`
      if (
        this.invalidBankPartyStatus.includes(this.bankPartyStatus) ||
        !this.validKycStatus.includes(this.kycStatus) || (this.isSmeLogin && !this.enableTermsAndConditionsConsent && !await this.verifySmeRelatedPartyKycStatus())
      ) {
        this.$refs.loginForm.reset()
        this.loaderEnabled = false
        await preload.refreshToken('', true)
        this.$store.dispatch('appStore/setAppData', {
          message: {
            title: this.$t('login.bankPartyStatus.title'),
            content: this.$t(this.messageContent),
            type: 'error',
            saveButton: this.$t('common.okay'),
            cancelCallback: () => this.clearSessionStorageExcept(['navigationMenu', 'genericCodes']),
            width: 450,
            icon: 'mdi-information-outline',
            component: 'dob-modal'
          }
        })
      } else {
        this.digiAccess = isDigiAccessAllowed
        // ListOfAccounts API call
        /* this.customerCode -> For personal & sme , this will be the customerCode
       this.feusId -> For sme, this will be the corporateId
                      For personal, this will be the customerCode  */
        if (!this.enableTermsAndConditionsConsent || (this.enableTermsAndConditionsConsent ? ((this.currentDate < this.checkUpdatedTCFromDate) && this.lastLoginTimeStamp) : false)) {
          this.getAccInfoAndNavigateToHome()
        }
        // this.loaderEnabled = false
      }
    })
    event.$on('IS_LOGIN_OTP_VALID', async valid => {
      await this.processLogin()
    })
    event.$on('stopLoader', arg => {
      this.loaderEnabled = false
    })
    store.dispatch('profileStore/setProfileData', { logout: false })
    event.$on('resetLoginForm', arg => {
      this.$refs.loginForm.reset()
      this.loaderEnabled = false
    })
    event.$once('routeToHome', arg => {
      this.getAccInfoAndNavigateToHome()
    })
  },
  beforeDestroy () {
    event.$off('DIGITAL_CHANNEL_ACCESS', false)
    event.$off('IS_LOGIN_OTP_VALID')
  },
  computed: {
    loginLabel () {
      const option = this.$appSettings.defaultConfigurations.loginPageScreens.userLoginIdMode

      if (this.showSmeField) {
        return this.$t('common.loginusernamePlaceholder')
      }

      switch (option) {
        case 'LoginID':
          return this.$t('common.loginusernamePlaceholder')
        case 'EmailID':
          return this.$t('common.loginusernameEmailPlaceholder')
        default:
          return this.$t('common.loginusernameWithEmailPlaceholder')
      }
    },
    maxLength () {
      const config = this.$appSettings.defaultConfigurations.loginPageScreens

      if (this.showSmeField) {
        return config.usernameMaxLength
      }

      return config.userLoginIdMode === 'LoginID'
        ? config.usernameMaxLength
        : config.usernameWithEmailMaxLength
    },
    emailRegex () {
      const pattern = this.$appSettings.defaultConfigurations.loginPageScreens.emailValidationRegex
      return new RegExp(pattern)
    },
    loginInputRules () {
      return [
        v => !!v || this.$t('login.loginIdRequiredMessage'),

        v => {
          const loginOption = this.$appSettings.defaultConfigurations.loginPageScreens.userLoginIdMode
          if (loginOption === 'LoginID' && this.emailRegex.test(v) && !this.showSmeField) {
            return this.$t('login.invalidLoginIdMessage')
          } else if (loginOption === 'EmailID' && !this.emailRegex.test(v) && !this.showSmeField) {
            return this.$t('login.invalidEmailIdMessage')
          }

          return true
        }
      ]
    },
    isLoginButtonDisabled () {
      return this.isLoginIdValid
    }
  },
  methods: {
    async verifySmeRelatedPartyKycStatus () {
      const smePartyDetails = await commonService.getCustomerDetails(this.feusId)
      const { basicDetails: { kycStatus = undefined } = {} } = smePartyDetails
      if (!this.validKycStatus.includes(kycStatus)) {
        if (kycStatus) this.messageContent = `login.invalidKycStatus.KYC_STATUS_${this.kycStatuses[kycStatus]}`
        return false
      }
      return true
    },
    async getAccInfoAndNavigateToHome () {
      if (this.isCustomerAuthorized) {
        // For SME login - remove not permitted account display from dashboard
        if (this.isSmeLogin && this.enableRoleBasedAccess) await preload.removeNotPermittedAccountSection()
        if (this.isSmeLogin && this.enableTermsAndConditionsConsent) {
          await preload.getCustomerDetails(this.customerCode)
        }
        await preload.getListOfAccounts(this.feusId)
        await preload.getListOfLoanAccounts(this.feusId)
        this.routeToHome()
      }
    },
    handleGAEvent ({ event, category, label }) {
      this.$gtag.event(event, {
        event_category: category,
        event_label: label,
        value: 1
      })
    },
    handleTabChange () {
      // reset form, also reset if error'd previously
      this.$refs.loginForm.reset()
      this.errorLogin = false
      this.errorMessage = undefined
      // below code handles the css class toggle when switching the tabs
      // show class when removed will reduce the field height to 0 but i want the element to be removed from the DOM
      if (this.currentTab === 1) {
        this.showSmeField = true
        this.toggleShowClass()
      } else {
        this.toggleShowClass()
        // delay is required before removing the element from DOM, otherwise css transition won't work
        setTimeout(() => {
          this.showSmeField = false
        }, 500)
      }
    },
    toggleShowClass () {
      setTimeout(() => {
        this.showClass = this.showClass ? '' : 'show'
      }, 10)
    },
    onOtpModalClose () {
      this.showOTPScreen = false
      this.otpModalConfig.enabled = false
      this.loaderEnabled = false
    },
    getAppDefaultConfig () {
      this.enableBgImage = this.$appSettings.defaultConfigurations.enableCustomBackgroundImage
      this.showBgImage = true
      this.image = this.enableBgImage ? this.$appSettings.serverSettings?.baseUrl + 'assets/custom/images/login.jpg' : defaultBgImage
      // Login form is configurable, values -  'Personal' or 'SME' or 'Both'
      // when default form is SME set to show the input field and add the show class
      const defaultForm = this.$appSettings.defaultConfigurations.loginPageScreens.loginMode.toLowerCase()
      // Set the defaultSelectedLoginMode as per configurations
      const defaultSelectedLoginMode = this.$appSettings.defaultConfigurations.loginPageScreens.defaultSelectedLoginMode
      switch (defaultForm) {
        case 'personal':
          this.showSmeField = false
          this.currentTab = 0
          break
        case 'sme':
          this.showClass = 'show'
          this.showSmeField = true
          this.currentTab = 1
          break
        case 'both':
          this.showTabs = true
          if (defaultSelectedLoginMode.toLowerCase() === 'personal') {
            this.currentTab = 0
            this.showSmeField = false
          } else {
            this.currentTab = 1
            this.showSmeField = true
            this.showClass = 'show'
          }
          break
      }
    },
    focus () {
      this.hasFocus = this.email
      if (!this.hasFocus) {
        this.btndisabled = true
      } else {
        this.btndisabled = false
      }
    },
    openContactUs () {
      window.open(this.$appSettings.applicationSettings.contactUs)
    },
    clear () {
      this.email = ''
      this.userpassword = ''
      this.btndisabled = true
    },
    isDigiAccessAllowed () {
      return this.$store.getters['profileStore/profileData']
        .isDigiAccessAllowed
    },
    set: (k, v) => sessionStorage.setItem(k, JSON.stringify(v)),
    get: (k) => JSON.parse(sessionStorage.getItem(k)),
    async init (data) {
      this.loaderEnabled = true
      this.set('isSmeLogin', false)
      let userLoginId

      // for store
      if (data) {
        const defaultConfigurations = this.$appSettings.defaultConfigurations
        const authConfigurations = this.$appSettings.authConfigurations
        if (authConfigurations.enableB2C) {
          const body = {
            bankCode: defaultConfigurations.bankCode,
            appCode: defaultConfigurations.appCode
          }
          if (data.accessToken) {
            await commonService.getB2CuserPermissions(body).then(
              async (resp) => {
                if (resp && resp.customerCode) {
                  userLoginId = resp.userLoginId
                  /**
                      SME uses the corprate code instead of customer id to get user/account details,
                      default corporate code can change ? Not sure, so check if SME login is available in the userCorporates list and then use the user entered login Id
                  */
                  this.isSmeIdAvailableInUserCoporates = resp.userCorporates?.some(corporate => corporate.corporateCode === this.corporateId)
                  this.feusId = this.isSmeIdAvailableInUserCoporates && this.currentTab === 1 ? this.corporateId : resp.customerCode
                  this.isCustomerAuthorized = true
                  // if sme login set the customer code in local storage - might come to use else where
                  this.isSmeIdAvailableInUserCoporates && sessionStorage.setItem('customerCode', JSON.stringify(resp.customerCode))
                  sessionStorage.setItem('username', JSON.stringify(this.feusId))
                  sessionStorage.setItem('userSession', true)

                  const { set } = this
                  this.customerCode = resp.customerCode
                  set('customerCode', resp.customerCode)
                  set('corporateId', this.corporateId)
                  this.isSmeLogin = this.currentTab === 1
                  set('isSmeLogin', this.isSmeLogin)
                  set('defaultCorporateCode', resp.defaultCorporateCode)
                  set('lastLoginTimeStamp', resp.lastLoginTimeStamp)
                  this.lastLoginTimeStamp = resp.lastLoginTimeStamp
                  const userCorporates = []
                  resp.userCorporates?.forEach((c) => {
                    userCorporates.push({ corporateCode: c.corporateCode, corporateDescription: '', formattedDescription: '' })
                  })
                  set('userCorporates', userCorporates)
                  // getSmeRoles
                  if (this.isSmeLogin && this.enableRoleBasedAccess) {
                    await this.getRolesAccess()
                  }
                } else {
                  this.isCustomerAuthorized = false
                  sessionStorage.setItem('username', JSON.stringify(this.feusId))
                }
              },
              error => {
                handleError(error)
                this.isCustomerAuthorized = false
              }
            )
          }
        } else {
          this.feusId = this.email
          sessionStorage.setItem('username', JSON.stringify(this.feusId))
          sessionStorage.setItem('userSession', true)
        }

        sessionStorage.setItem('userId', JSON.stringify(userLoginId || this.email))
        this.$store.dispatch('userStore/setUserData', {
          username: this.feusId,
          userSession: true
        })
        this.$store.dispatch('profileStore/setProfileData', {
          userSession: true
        })
      } else {
        sessionStorage.setItem('username', JSON.stringify(this.email))
        this.$store.dispatch('userStore/setUserData', {
          username: this.email,
          userSession: true
        })
        this.$store.dispatch('profileStore/setProfileData', {
          userSession: true
        })
        sessionStorage.setItem('userSession', 'true')
      }
      this.isCustomerAuthorized ? await this.loadData() : this.loaderEnabled = false
    },
    async getRolesAccess () {
      let roles = []
      roles = await this.getAssignedRoles(this.customerCode, this.corporateId)
      if (roles && roles.length > 0) {
        this.$store.dispatch('profileStore/setProfileData', {
          isSme: this.isSmeLogin,
          permissions: roles
        })
        return roles
      } else {
        this.isCustomerAuthorized = false
        this.$store.dispatch('appStore/setAppData', {
          message: {
            title: this.$t('login.digitalChannelAccess.title'),
            content: this.$t('errors.common.apiReqFail'),
            type: 'error',
            saveButton: this.$t('common.okay'),
            width: 450,
            icon: 'mdi-information-outline',
            component: 'dob-modal'
          }
        })
      }
      // TODO - Handle negative case - no roles assigned to the user
      // TODO - Handle error case - getRolesAccess API failed
    },
    // loads customer data
    async loadData () {
      // For SME login - remove not permitted account display from dashboard
      if (this.isSmeLogin && this.enableRoleBasedAccess) await preload.removeNotPermittedAccountSection()
      // Fetch party details
      /** for sme customer we are not getting the details of the enterprise, we are getting the details of the customer instead */
      this.feusId
        ? await preload.getCustomerDetails((this.isSmeLogin && this.enableTermsAndConditionsConsent)
          ? this.feusId
          : this.isSmeLogin ? this.customerCode : this.feusId)
        : await preload.getCustomerDetails(this.email)
      // Check T&C
      if (!this.invalidBankPartyStatus.includes(this.bankPartyStatus) &&
        this.validKycStatus.includes(this.kycStatus) && this.enableTermsAndConditionsConsent &&
        ((this.currentDate >= this.checkUpdatedTCFromDate) || !this.lastLoginTimeStamp)
      ) {
        // let searchId = this.isSmeLogin ? this.customerCode : this.feusId
        await this.getConsentData(this.feusId)
      }
    },
    routeToHome () {
      // check - DigitalChannel Access for the customer
      if (this.digiAccess || this.isDigiAccessAllowed()) {
        setTimeout(() => {
          this.loaderEnabled = false
          this.$router.push({ name: 'Home', params: { from: 'login' } })
          // TODO this.$router.push('/home')
        }, 200)
      } else {
        this.loaderEnabled = false
        this.$store.dispatch('appStore/setAppData', {
          message: {
            title: this.$t('login.digitalChannelAccess.title'),
            content: this.$t('login.digitalChannelAccess.content'),
            type: 'error',
            saveButton: this.$t('common.okay'),
            width: 450,
            icon: 'mdi-information-outline',
            component: 'dob-modal'
          }
        })
      }
    },
    async processResponse (resp, headers) {
      if (resp && resp.expiresIn && resp.refreshExpiresIn) {
        sessionStorage.setItem(`access_t_${window.name}`, resp.accessToken)
        sessionStorage.setItem(`access_r_${window.name}`, resp.refreshToken)
        this.isCustomerAuthorized = true
        if (this.errorLogin) {
          this.errorLogin = false
          this.errorMessage = undefined
        }
        // this.refreshAuth(resp)
        this.$store.dispatch('appStore/setAppData', { b2cData: resp })
        await this.init(resp)
      } else if (resp && resp.expires_in) {
        sessionStorage.setItem(`access_t_${window.name}`, resp.access_token)
        this.isCustomerAuthorized = true
        if (this.errorLogin) {
          this.errorLogin = false
          this.errorMessage = undefined
        }
        await this.init(resp)
      } else {
        if (resp && resp.causes[0]?.code) {
          // Temporary Password -  FEUS-000069
          // Password Expiry - FEUS-000092
          const errCode = resp.causes[0].code
          if (errCode === 'FEUS-000069') {
            this.screenActions({ type: 'changeTemporaryPassword', subType: 'temporaryPassword' })
          }
          if (errCode === 'FEUS-000092') {
            this.screenActions({ type: 'changeTemporaryPassword', subType: 'passwordExpiry' })
          }
        }
        this.isCustomerAuthorized = false
        this.errorLogin = true
        this.errorMessage = this.$t('login.invalidLoginMessage')
      }
    },
    async login () {
      if (this.enableOTP) {
        if ((!this.email || !this.userpassword) || (this.currentTab === 1 && !this.corporateId)) {
          this.errorLogin = true
          return
        }
        sessionStorage.setItem('userId', this.email)
        this.set('isSmeLogin', this.currentTab === 1)
        this.showOTPScreen = true
        this.otpModalConfig.enabled = true
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 1000)
      } else {
        await this.processLogin()
      }
    },
    async processLogin () {
      if (this.$appSettings.authConfigurations.enableMock) {
        if (this.email === 'PTY0001' && this.userpassword === 'password') {
          this.isCustomerAuthorized = true
          await this.init()
        } else {
          this.isCustomerAuthorized = false
          this.errorLogin = true
          this.errorMessage = this.$t('login.invalidLoginMessage')
        } // Personal Login handler
      } else {
        this.handleGAEvent({ event: 'SignIn', category: 'authentication', label: 'login button clicked' })
        if (this.email && this.userpassword) {
          const body = {
            userLoginId: hashed(this.email),
            password: hashed(this.userpassword)
          }

          if (this.currentTab === 1) {
            if (this.corporateId) {
              body.corporateCode = hashed(this.corporateId)
            } else {
              this.errorLogin = true
              return
            }
          }

          await commonService.login(body).then(
            (resp) => {
              if (this.enableOTP) {
                event.$emit('reset_OTPField', true)
              }

              if (resp && resp.data && resp.data.internalType === 'OTP-ERROR') {
                event.$emit('otp_validation_failed', resp.data)
                return
              }

              if (this.enableOTP) {
                this.showOTPScreen = false
                this.otpModalConfig.enabled = false
                sessionStorage.removeItem('userId', this.email)
              }

              (this.$appSettings.authConfigurations.enableB2C && resp?.data && resp?.headers) ? this.processResponse(resp.data, resp.headers) : this.processResponse(resp)
            },
            error => {
              this.isCustomerAuthorized = false
              handleError(error)
            }
          )// SME Login handler
        } else {
          this.errorLogin = true
          // this.errorMessage = this.$t('login.invalidLoginMessage')
        }
      }
    },
    screenActions ({ type, subType }) {
      const actionType = type
      this.currentActionType = actionType
      switch (actionType) {
        case 'resetPassword':
          // this.currentActionType = 'Reset Password'
          this.resetPassword = true
          break
        case 'retrieveLoginId':
          // this.currentActionType = 'Forgot User Id'
          this.retrieveLoginId = true
          break
        case 'registerForOnlineBanking':
          // this.currentActionType = 'Activate User'
          this.registerForOnlineBanking = true
          break
        case 'changeTemporaryPassword':
          // this.currentActionType = 'Change Temporary Password'
          this.isChangeTemporaryPassword = true
          break
      }
      this.$router.push({
        name: 'Register',
        params: {
          actionType: actionType,
          userLoginID: this.email,
          changePasswordType: subType || '',
          isSmeLogin: this.currentTab === 1
        }
      })
    },
    handleLoginActions () {
      this.resetPassword = false
      this.retrieveLoginId = false
      this.registerForOnlineBanking = false
      this.isChangeTemporaryPassword = false
    },
    openFaq () {
      this.modalConfig.enabled = true
    },
    validateLoginField () {
      const rules = this.loginInputRules
      const errorLoginRule = rules.find(rule => rule(this.email) !== true)
      this.isLoginIdValid = errorLoginRule
    }
  }
}
</script>
